<template>
  <span class="dropdownStyle">
    <div>
      <v-menu
        :nudgeTop="isFirstCall ? height : 0"
        :closeOnContentClick="false"
        :offsetX="isOffsetX"
        :offsetY="isOffsetY"
        v-model="openMenu"
        :left="isLeft"
        max-height="300"
      >
        <template v-slot:activator="{ on }">
          <v-list-item
            v-if="isSubMenu"
            :class="{ 'pl-1': isLeft, 'pr-1': !isLeft }"
            @click="parentEvent(item)"
          >
            <template v-if="isLeft">
              <v-btn icon v-on="on" class="mr-1">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <div class="flex-grow-1"></div>
            </template>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <template v-if="!isLeft">
              <div class="flex-grow-1"></div>
              <v-btn icon v-on="on" class="ml-1">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </template>
          </v-list-item>
          <v-select
            v-else
            v-model="inputedValue"
            item-text="name"
            item-value="productCategoryId"
            v-on="on"
            :items="flattedItems"
            :menu-props="{ disabled: flattedItems.length > 0 }"
            dense
            outlined
            return-object
            class="original-selectbox"
            hide-details
            :placeholder="$t('sale.sale_product-category')"
            :height="height"
            clearable
          >
          </v-select>
        </template>
        <v-list dense>
          <template v-for="(item, index) in items">
            <!-- ネストが続く限り再帰的にコンポーネントを呼び出す -->
            <SelectProductCategory
              v-if="item.childProductCategoryList.length > 0"
              :key="index"
              :item="item"
              :nestedItems="item.childProductCategoryList"
              :isOffsetX="true"
              :isOffsetY="false"
              :isSubMenu="true"
              :isLeft="isLeft"
              @parentEvent="parentEvent"
            />
            <v-list-item v-else :key="index" @click="parentEvent(item)">
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
    </div>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SelectProductCategory',
  components: {},
  props: {
    item: { type: Object, default: () => {} },
    nestedItems: { type: Array, default: () => [] },
    isOffsetX: { type: Boolean, default: false },
    isOffsetY: { type: Boolean, default: true },
    isSubMenu: { type: Boolean, default: false },
    isLeft: { type: Boolean, default: true },
    value: { default: '' },
    height: { default: '32px' }
  },
  data: () => ({
    openMenu: false,
    items: []
  }),
  created() {
    // 再帰的に呼ばれた同コンポーネントに対しては下層itemが入ってくる
    this.items = this.isFirstCall
      ? this.getProductCategoryFromState()
      : this.nestedItems
  },
  methods: {
    ...mapGetters('Common', ['getProductCategoryFromState']),
    selectItem(item) {
      this.inputedValue = item.productCategoryId
      this.openMenu = false
    },
    // 再帰的に呼ばれる同コンポーネントに対してはemitイベントをセットしておく
    parentEvent(item) {
      this.isFirstCall ? this.selectItem(item) : this.$emit('parentEvent', item)
    }
  },
  computed: {
    // 結果表示用に平坦化しておく
    flattedItems() {
      const flattedItems = []
      const flatten = (items) => {
        items.forEach((item) => {
          ;(item.childProductCategoryList.length > 0 &&
            flatten(item.childProductCategoryList)) ||
            flattedItems.push({
              name: item.name,
              productCategoryId: item.productCategoryId
            })
        })
      }
      flatten(this.getProductCategoryFromState())
      return flattedItems
    },
    // 発火元のコンポーネントかどうかはこれで判断してください
    isFirstCall() {
      return this.nestedItems.length === 0
    },
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.dropdownStyle {
  height: 32px;
}
</style>
